import { format_routes } from '@/utils/tools';
import { lazy } from 'react';


const AllocationMarketRate = lazy(() => import('../pages/allocations/market/rate'));
const AllocationMarketExternalPrice = lazy(() => import('../pages/allocations/market/externalPrice'));
const AllocationMarketListPrice = lazy(() => import('../pages/allocations/market/listPrice'));
const AllocationsCenterMarket = lazy(() => import('../pages/allocations/center/market'));
const AllocationsCenterPoultryMarket = lazy(() => import('../pages/allocations/center/poultryMarket'));
const AllocationsCenterMarketDelivery = lazy(() => import('../pages/allocations/center/delivery'));
const AllocationsCenterMarketPoultryDelivery = lazy(() => import('../pages/allocations/center/poultryDelivery'));
// const AllocationsCenterDemand = lazy(() => import('../pages/allocations/centerDemand'));
const AllocationsCenterTask = lazy(() => import('../pages/allocations/center/task'));
const AllocationsCenterPoultryTask = lazy(() => import('../pages/allocations/center/poultryTask'));
const AllocationsCenterTaskDetail = lazy(() => import('../pages/allocations/center/taskDetail'));
const AllocationsCenterPoultryTaskDetail = lazy(() => import('../pages/allocations/center/poultryTaskDetail'));
const AllocationsCenterPurchasePrice = lazy(() => import('../pages/allocations/center/purchasePrice'));
const AllocationsCenterSupplierPrice = lazy(() => import('../pages/allocations/center/supplierPrice'));
const AllocationsCenterSupplierPurchasePrice = lazy(() => import('../pages/allocations/center/supplierPurchasePrice'));
const AllocationDashboardInventoryBoard = lazy(() => import('../pages/allocations/dashboard/inventory'));
const AllocationDashboardPriceBoard = lazy(() => import('../pages/allocations/dashboard/price'));

// 调配建议板块
// 欢迎页
const SuggestWelcome = lazy(() => import('../pages/allocations/suggest/suggestWelcome'));
// -- 基础数据 --
// 公司主数据
const MainCompany = lazy(() => import('../pages/allocations/suggest/mainCompany'));
// 客户主数据
const MainCustomer = lazy(() => import('../pages/allocations/suggest/mainCustomer'));
// 物流主数据
const MainLogistics = lazy(() => import('../pages/allocations/suggest/mainLogistics'));
// 公司间距离
const CompanyDistance = lazy(() => import('../pages/allocations/suggest/companyDistance'));
// 部位与商品关系
const PartProductsRelationship = lazy(() => import('../pages/allocations/suggest/partProductsRelationship'));
// 工厂商品主数据
const MainFactoryProducts = lazy(() => import('../pages/allocations/suggest/mainFactoryProducts'));

// -- 报表数据 --
// CPM省区订单数据
const CpmProvinceOrderData = lazy(() => import('../pages/allocations/suggest/cpmProvinceOrderData'));
// 工厂部位库存量
const AllocationsPartStock = lazy(() => import('../pages/allocations/suggest/partStock'));
// 工厂渠道订单量
const AllocationsSuggestFactoryOrder = lazy(() => import('../pages/allocations/suggest/factoryOrder'));
// 工厂订单不满足
const AllocationsOrderInsufficient = lazy(() => import('../pages/allocations/suggest/orderInsufficient'));

// const AllocationSuggest = lazy(() => import('../pages/allocations/components/allocationSuggest'));

// -- 调配任务执行 --
// 调配任务参数调整
const AllocationTaskParameters = lazy(() => import('../pages/allocations/suggest/allocationTaskParameters'));
// 调配任务（旧：工厂到战区）
const AllocationsSuggestFactory = lazy(() => import('../pages/allocations/suggest/factory'));
// 调配任务-同步成功
const SyncSuccess = lazy(() => import('../pages/allocations/suggest/factory/syncSuccess'));
// 调配任务-销售单完成
const SyncOrderComplete = lazy(() => import('../pages/allocations/suggest/factory/syncOrderComplete'));



export const allocationsCenterChildrenRouter = [
  {
    path: '/allocations/center/market',
    element: <AllocationsCenterMarket />,
    key: 'allocationsCenterMarket',
    parentKey: 'allocationsCenter',
    label: 'Pork Delivery Market', //交割大盘
  },
  {
    path: '/allocations/center/market/delivery',
    element: <AllocationsCenterMarketDelivery />,
    key: 'allocationsCenterMarketDelivery',
    parentKey: 'allocationsCenter',
    label: 'Current Delivery Suggestions', //本期交割建议
  },
  {
    path: '/allocations/center/task',
    element: <AllocationsCenterTask />,
    key: 'allocationsTask',
    parentKey: 'allocationsTask',
    label: 'Pork Task List', //任务列表
  },
  {
    path: '/allocations/center/purchasePrice',
    element: <AllocationsCenterPurchasePrice />,
    key: 'allocationsCenterPurchasePrice',
    parentKey: 'allocationsCenterPurchasePrice',
    label: 'Buyer Prices', //需求方价格
  },
  {
    path: '/allocations/center/supplierPrice',
    element: <AllocationsCenterSupplierPrice />,
    key: 'allocationsCenterSupplierPrice',
    parentKey: 'allocationsCenterSupplierPrice',
    label: 'Supplier Prices', //供应方价格
  },
  {
    path: '/allocations/center/supplierPurchasePrice',
    element: <AllocationsCenterSupplierPurchasePrice />,
    key: 'allocationsCenterSupplierPurchasePrice',
    parentKey: 'allocationsCenterSupplierPurchasePrice',
    label: 'Supplier Purchase Prices', //供需方价格
  },
  {
    path: '/allocations/center/task/detail',
    element: <AllocationsCenterTaskDetail />,
    key: 'allocationsCenterTaskDetail',
    parentKey: 'allocationsCenterTaskDetail',
    label: '任务列表详情', //任务列表详情
    hidden: true,
  },
  {
    path: '/allocations/center/poultryMarket',
    element: <AllocationsCenterPoultryMarket />,
    key: 'allocationsCenterPoultryMarket',
    parentKey: 'allocationsCenter',
    label: 'Poultry delivery market​', //禽肉交割大盘
  },
  {
    path: '/allocations/center/poultryTask',
    element: <AllocationsCenterPoultryTask />,
    key: 'allocationsPoultryTask',
    parentKey: 'allocationsTask',
    label: 'Poultry Task List', //任务列表
  },
  {
    path: '/allocations/center/poultryTask/detail',
    element: <AllocationsCenterPoultryTaskDetail />,
    key: 'allocationsCenterPoultryTaskDetail',
    parentKey: 'allocationsCenterTaskDetail',
    label: '禽肉任务列表详情', //任务列表详情
    hidden: true,
  },
  {
    path: '/allocations/center/poultryMarket/delivery',
    element: <AllocationsCenterMarketPoultryDelivery />,
    key: 'allocationsCenterMarketPoultryDelivery',
    parentKey: 'allocationsCenter',
    label: '禽肉本期交割建议', //交割大盘
  }
];


// 调配建议 - 包含三大子菜单（基础数据、报表数据、调配任务执行）
export const allocationsSuggestChildrenRouter = [
  {
    path: '/allocations/suggest/basedata',
    key: 'deliverySuggestBaseData',
    parentKey: 'deliverySuggest',
    label: 'Base Data', // 基础数据
    element: <SuggestWelcome />,
    children: [
      {
        path: '/allocations/suggest/basedata/maincompany',
        index: true,
        element: <MainCompany />,
        key: 'deliverySuggestCompanys',
        parentKey: 'deliverySuggestBaseData',
        label: 'Company Master Data', // 公司主数据
      },
      {
        path: '/allocations/suggest/basedata/maincustomer',
        element: <MainCustomer />,
        key: 'deliverySuggestCustomers',
        parentKey: 'deliverySuggestBaseData',
        label: 'Customer Master Data', // 客户主数据
      },
      {
        path: '/allocations/suggest/basedata/logisticsmain',
        element: <MainLogistics />,
        key: 'deliverySuggestLogistics',
        parentKey: 'deliverySuggestBaseData',
        label: 'Logistics Master Data', // 物流主数据
      },
      {
        path: '/allocations/suggest/basedata/companydistance',
        element: <CompanyDistance />,
        key: 'deliverySuggestCompanysDistance',
        parentKey: 'deliverySuggestBaseData',
        label: 'Inter company Distance', // 公司间距离
      },
      {
        path: '/allocations/suggest/basedata/partproducts',
        element: <PartProductsRelationship />,
        key: 'deliverySuggestPartProductsMap',
        parentKey: 'deliverySuggestBaseData',
        label: 'Part to Product Relationship', // 部位与商品关系
      },
      {
        path: '/allocations/suggest/basedata/mainfactoryproducts',
        element: <MainFactoryProducts />,
        key: 'deliverySuggestFactoryProducts',
        parentKey: 'deliverySuggestBaseData',
        label: 'Factory Product Master Data', // 工厂商品主数据
      },

    ]
  },
  {
    path: '/allocations/suggest/report',
    key: 'deliverySuggestReport',
    parentKey: 'deliverySuggest',
    label: 'Report Data', // 报表数据
    children: [
      {
        path: '/allocations/suggest/report/factory',
        element: <CpmProvinceOrderData />,
        key: 'deliverySuggestCpmOrders',
        parentKey: 'deliverySuggestReport',
        label: 'CPM Province Order Data', // CPM省区订单数据
      },

      {
        path: '/allocations/suggest/report/partStock',
        element: <AllocationsPartStock />,
        key: 'allocationsPartStock',
        parentKey: 'deliverySuggestReport',
        label: 'Factory Part Inventory', // 工厂部位库存量
      },
      {
        path: '/allocations/suggest/report/factoryOrder',
        element: <AllocationsSuggestFactoryOrder />,
        key: 'allocationsFactoryOrder',
        parentKey: 'deliverySuggestReport',
        label: 'Factory Channel Orders', // 工厂渠道订单量
      },
      {
        path: '/allocations/suggest/report/orderInsufficient',
        element: <AllocationsOrderInsufficient />,
        key: 'allocationsOrderInsufficient',
        parentKey: 'deliverySuggestReport',
        label: 'Allocations Order Insufficient', // 工厂订单不满足
      },
    ]
  },
  {
    path: '/allocations/suggest/task',
    key: 'deliverySuggestExecute',
    parentKey: 'deliverySuggest',
    label: 'Allocation Task Execution', // 调配任务执行
    children: [
      {
        path: '/allocations/suggest/task/parameters',
        element: <AllocationTaskParameters />,
        key: 'deliverySuggestParams',
        parentKey: 'deliverySuggestExecute',
        label: 'Allocation Task Parameters', // 调配任务参数
      },

      {
        path: '/allocations/suggest/task/factory',
        element: <AllocationsSuggestFactory />,
        key: 'allocationsSuggestFactory',
        parentKey: 'deliverySuggestExecute',
        label: 'Allocation Task', // 调配任务（旧名称：工厂到战区）
      },
      {
        path: '/allocations/suggest/task/factory/syncOrder/success/:id',
        element: <SyncSuccess />,
        key: 'syncSuccess',
        label: 'Sync Success', // 销售单生成-同步成功
        hidden: true,
        parentKey: 'deliverySuggestExecute'
      },
      {
        path: '/allocations/suggest/task/factory/syncOrder/complete/:id',
        element: <SyncOrderComplete />,
        key: 'syncOrderComplete',
        label: 'SyncOrder Complete', // 销售单完成
        hidden: true,
        parentKey: 'deliverySuggestExecute'
      },

    ]
  },
];

export const allocationMarketChildrenRouter = [
  {
    path: '/allocations/market/rate',
    element: <AllocationMarketRate />,
    key: 'allocationMarketRate',
    parentKey: 'allocationsMarket',
    label: 'Pork Yield Rate', //猪出品率
  },
  {
    path: '/allocations/market/listPrice',
    element: <AllocationMarketListPrice />,
    key: 'allocationMarketListPrice',
    parentKey: 'allocationsMarket',
    label: 'Daily Price Bulletin​', //调配-每日牌价
  },
  {
    path: '/allocations/market/externalPrice',
    element: <AllocationMarketExternalPrice />,
    key: 'allocationMarketExternalPrice',
    parentKey: 'allocationsMarket',
    label: 'External Market Price', //外部市场价格
    // hidden: true,
  },
];
export const allocationDashboardChildrenRouter = [
  {
    path: '/allocations/dashboard/inventoryBoard',
    element: <AllocationDashboardInventoryBoard />,
    key: 'allocationsDashboardInventory',
    parentKey: 'allocationsDashboard',
    label: 'Inventory Dashboard', //库存看板
  },
  {
    path: '/allocations/dashboard/priceBoard',
    element: <AllocationDashboardPriceBoard />,
    key: 'allocationsDashboardPrice',
    parentKey: 'allocationsDashboard',
    label: 'Price Dashboard', //价格看板
  },
];

export const allocationsRouter = [
  {
    path: '/allocations/center',
    key: 'allocationsCenter',
    label: 'Allocations Center', //猪调配中心,
    parentKey: 'AllocationsIndex',
    children: allocationsCenterChildrenRouter
  },
  {
    path: '/allocations/suggest',
    key: 'deliverySuggest',
    label: 'Allocations Suggest', //调配建议,
    parentKey: 'AllocationsIndex',
    children: allocationsSuggestChildrenRouter
  },
  {
    path: '/allocations/market',
    key: 'allocationsMarket',
    label: 'Allocations Market', //全国猪肉行情,
    parentKey: 'AllocationsIndex',
    children: allocationMarketChildrenRouter
  },
  {
    path: '/allocations/dashboard',
    key: 'allocationsDashboard',
    label: 'Allocations Dashboard', //内部数据看版,
    parentKey: 'AllocationsIndex',
    children: allocationDashboardChildrenRouter
  },
];
export const format_allocations_router_routes = format_routes(allocationsRouter);